import { createSlice } from '@reduxjs/toolkit';
import { addNewModelCode, editModelCode, getAllModelCodes, getModelCodesByModelId } from './modelCodesService';

const initialState = {
  allModelCodes: {
    isModelCodesLoading: null,
    isModelCodesSuccess: null,
    modelsMessage: null,
    pageCount: 0,
    modelCodes: [],
  },
  newModelCode: {
    isModelCodeCreating: null,
    isModelCodeCreated: null,
    modelCodeCreationMsg: null,
  },

  editedModelCode: {
    isEditingModelCode: null,
    isModelCodeEdited: null,
    modelCodeEditedMsg: null
  },

  allModelCodesByModelId: {
    isModelCodesByModelLoading: null,
    isModelCodesByModelSuccess: null,
    modelCodesByModelMessage: null,
    modelCodesByModel: [],
  },
};

const modelCodesSlice = createSlice({
  name: 'modelCode',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // PENDING
    builder
      .addCase(getAllModelCodes.pending, (state) => {
        state.allModelCodes = {
          ...initialState.allModelCodes, // Reset to initial state
          isModelCodesLoading: true,
          modelCodesMessage: 'Loading',
        };
      })

      // REJECTED
      .addCase(getAllModelCodes.rejected, (state, action) => {
        state.allModelCodes = {
          ...initialState.allModelCodes,
          isModelCodesLoading: false,
          isModelCodeCodesSuccess: false,
          modelCodesMessage: action.payload || 'Error occurred while fetching model codes',
        };
      })

      // FULFILLED
      .addCase(getAllModelCodes.fulfilled, (state, action) => {
        state.allModelCodes = {
          ...initialState.allModelCodes,
          isModelCodesLoading: false,
          isModelCodeCodesSuccess: true,
          pageCount: action.payload.pageCount || 0,
          modelCodes: action.payload.data || [],
        };
      });

    //ModelCode creating
    builder
      .addCase(addNewModelCode.pending, (state) => {
        state.newModelCode = {
          ...initialState.newModelCode, // Reset to initial state
          isModelCodeCreating: true,
          modelCodeCreationMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(addNewModelCode.rejected, (state, action) => {
        state.newModelCode = {
          ...initialState.newModelCode,
          isModelCodeCreating: false,
          isModelCodeCreated: false,
          modelCodeCreationMsg: action.payload || 'Error occurred while creating the model code.',
        };
      })

      // FULFILLED
      .addCase(addNewModelCode.fulfilled, (state, action) => {
        state.newModelCode = {
          ...initialState.newModelCode,
          isModelCodeCreating: false,
          isModelCodeCreated: true,
          modelCodeCreationMsg: action.payload || 'Successfully created the model code.',
        };
      });

    //ModelCode editing
    builder
      .addCase(editModelCode.pending, (state) => {
        state.editedModelCode = {
          ...initialState.editedModelCode, // Reset to initial state
          isEditingModelCode: true,
          modelCodeEditedMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(editModelCode.rejected, (state, action) => {
        state.editedModelCode = {
          ...initialState.editedModelCode, // Reset to initial state
          isEditingModelCode: false,
          isModelCodeEdited: false,
          modelCodeEditedMsg: action.payload || 'Error occurred while editing the model code.',
        };
      })

      // FULFILLED
      .addCase(editModelCode.fulfilled, (state, action) => {
        state.editedModelCode = {
          ...initialState.editedModelCode, // Reset to initial state
          isEditingModelCode: false,
          isModelCodeEdited: true,
          modelCodeEditedMsg: action.payload || 'Successfully edited the model code.',
        };
      });

      //Model codes by model
      builder
      .addCase(getModelCodesByModelId.pending, (state) => {
        state.allModelCodesByModelId = {
          ...initialState.allModelCodesByModelId,
          isModelCodesByModelLoading: true,
          modelCodesByModelMessage: 'Loading',
        };
      })

      // REJECTED
      .addCase(getModelCodesByModelId.rejected, (state, action) => {
        state.allModelCodesByModelId = {
          ...initialState.allModelCodesByModelId,
          isModelCodesByModelLoading: false,
          isModelCodesByModelSuccess: false,
          modelCodesByModelMessage: action.payload || 'An error occurred while getting model codes',
        };
      })

      // FULFILLED
      .addCase(getModelCodesByModelId.fulfilled, (state, action) => {
        state.allModelCodesByModelId = {
          ...initialState.allModelCodesByModelId,
          isModelCodesByModelLoading: false,
          isModelCodesByModelSuccess: true,
          modelCodesByModel: action.payload,
        };
      });
  },
});

export default modelCodesSlice.reducer;
